<template>
    <v-card>
        <material-card color="green" class="card-logs-card">
            <v-flex slot="header">
                <v-layout row>
                    <span
                        class="title font-weight-light mb-2"
                        style="align-self: center"
                        >Card & Document Logs ({{ cardLogs.length }})</span
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="toggleExpansion"
                        flat
                        icon
                        class="ma-0"
                        color="#fff"
                    >
                        <v-icon>{{
                            expanded
                                ? "mdi-minus-circle-outline"
                                : "mdi-plus-circle-outline"
                        }}</v-icon>
                    </v-btn>
                </v-layout>
            </v-flex>
            <v-progress-linear
                v-if="loading"
                :indeterminate="true"
                color="success"
            ></v-progress-linear>
            <div v-if="expanded">
                <div
                    v-if="cardLogs.length && !loading"
                    style="overflow-y: auto; max-height: 300px;"
                >
                    <div v-for="(log, index) in cardLogs">
                        <v-layout row wrap class="mt-2 mx-3 mb-2">
                            <div class="font-weight-light mr-2">
                                {{ log.cardPrintDate | time }}
                            </div>
                            <div class="font-weight-regular mr-2">
                                {{ log.byUser ? log.byUser : "Unknown" }}
                            </div>
                            <div class="font-weight-light mr-2">
                                {{
                                    log.actionType == "EMAIL"
                                        ? "Emailed"
                                        : "Printed"
                                }}
                            </div>
                            <div class="font-weight-regular">
                                {{ getLogType(log) }}
                            </div>
                        </v-layout>
                        <v-divider
                            class="mt-1 mb-3"
                            v-if="index + 1 < cardLogs.length"
                        ></v-divider>
                    </div>
                </div>
                <div
                    v-if="!cardLogs.length && !loading"
                    class="mt-2 text-xs-center"
                >
                    No Logs
                </div>
            </div>
        </material-card>
    </v-card>
</template>
<script>
export default {
    props: {
        cardLogs: { type: Array },
        loading: { type: Boolean },
    },
    data: () => ({
        expanded: false,
    }),
    async created() {},
    methods: {
        toggleExpansion() {
            this.expanded = !this.expanded;
        },
        getLogType(log) {
            switch (log.type) {
                case "GC_CARDS":
                case "GC_CARDS2":
                    return "Bus & Bunk Cards";
                case "GC_BUS":
                    return "Bus Cards";
                case "GC_BUNK":
                    return "Bunk Cards";
                case "GC_RULES":
                    return "תקנות בויגן";
                case "GC_FORM":
                    return "Health & Lunch Form";
                default:
                    return "Registration Cards";
            }
        },
    },
};
</script>
<style>
.card-logs-card .v-card--material__header.v-card {
    padding-top: 10px !important;
    padding-bottom: 10px !important;
}
</style>
